import type { ApiKeyUsageDetail } from './openai-api';

/**
 * Provider ownership metadata is not automatically spend attribution.
 *
 * Anthropic Claude Code keys are self-provisioned by the consuming user, so
 * their owner identity is trusted. OpenAI project keys and regular Anthropic
 * keys can be owned or created by an administrator while serving a shared
 * application, so their owner fields remain metadata-only unless an explicit
 * key mapping resolves them elsewhere.
 *
 * The fallback preserves cached Anthropic rows written before the explicit
 * provenance flag existed.
 */
export const hasTrustedPersonOwnerIdentity = (entry: ApiKeyUsageDetail): boolean => {
  if (entry.ownerType !== 'user') return false;
  if (entry.ownerIdentityTrusted !== undefined) return entry.ownerIdentityTrusted;

  return entry.provider === 'anthropic' && entry.name.startsWith('claude_code_');
};
